// Ei ole enää käytössä

const format = (tickItem) => {
  const dt = new Date(tickItem)
  const m = dt.toLocaleString('default', { month: 'long' })
  const d = dt.getDate()
  const formatDate ='      ' + m.substr(0,3) + '/' + d + '       '
  return formatDate
}

const formatLabel = (tickItem) => {
  const dt = new Date(tickItem).toLocaleString('fi-FI')
  return dt
}


const headers = [
  {
    label: 'Date', key: 'Date'
  },
  {
    label: 'Time', key: 'Time'
  },
  {
    label: 'Humidity', key: 'Humidity'
  },
  {
    label: 'Temperature', key:'Temperature'
  },

  {
    label: 'Air Pressure', key:'AirPressure'
  },
  {
    label: 'VOC', key: 'VOC'
  },
  {
    label: 'Luminance', key:'Luminance'
  }
]

const sensors = [
  {
    id: '1', name: 'Sensor 1', service: 'sisailma1'
  },
  {
    id: '4', name: 'Sensor 2', service: 'sisailma4'
  }
]

const graphService = {
  format,
  formatLabel,
  headers,
  sensors
}

export default graphService
